import { Box, List, ListItem } from "@mui/material";
import React, { useEffect, useState } from "react";
import { rotationIcon } from "./images";
import Text from "./text/Text";
import {
  alreadyExistUsername,
  btc,
  sats,
  save,
  setUpLnSubMessage,
  setUpNow,
  setYourUserName,
  setupLNAddressMessages,
  setupLnAddress,
  usdt,
  userNameLengthErrorMsg,
  userNameNotValid,
} from "./messages";
import { Input } from "./input/Input";
import Button from "./button/Button";
import "../assets/setupLn.scss";
import { callAPIInterface, userNameRegex } from "./constants";
import LnAddress from "./setupLnAddress/LnAddress";
import DynamicHeight from "./DynamicHeight";
import { useSelector } from "react-redux";

function SetupLnAddressCommon({
  isOpenModal,
  setIsOpenModal,
  directionToOpen,
  userName,
  setUserName,
  isFromBrowser,
  customClass,
  setIsAddressCreated,
  isIosDevice,
}) {
  const textSize = isFromBrowser ? 16 : 14;
  const [isLnAddressSetup, setIsLnAddressSetup] = useState(false);
  const [isValidUserName, setIsValidUserName] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState(userNameNotValid);

  DynamicHeight({ isIosDevice });

  const { uuid: currency } = useSelector((state) => state.common.taprootAsset);

  let text;
  if (currency === usdt) {
    text = "USDT Lightning";
  } else if (currency === sats) {
    text = "BTC Lightning";
  } else {
    text = "LN";
  }

  useEffect(() => {
    if (userName) {
      if (userNameRegex.test(userName) && userName.length >= 5) {
        setIsValidUserName(true);
      } else {
        setIsValidUserName(false);
        setErrorMsg(
          userName.length < 5 ? userNameLengthErrorMsg : userNameNotValid
        );
      }
    } else {
      setIsValidUserName(true);
      setErrorMsg(userNameNotValid);
    }
  }, [userName]);

  const handleSetup = () => {
    setIsLnAddressSetup(true);
  };

  const handleSave = async () => {
    const userNameData = {
      username: userName,
      domain: process.env.REACT_APP_DOMAIN,
    };
    try {
      setIsLoading(true);
      const data = await callAPIInterface(
        "POST",
        "/payment-addresses/validate",
        userNameData
      );
      if (data) {
        if (data?.is_available) {
          handleCreateUsername();
        } else {
          setIsLoading(false);
          setIsValidUserName(false);
          setErrorMsg(alreadyExistUsername);
        }
      }
    } catch (err) {
      setIsLoading(false);
    }
  };

  const handleCreateUsername = async () => {
    try {
      await callAPIInterface("POST", "/payment-addresses", {
        username: userName,
        currency,
      });
      setIsLoading(false);
      setIsAddressCreated(true);
    } catch (err) {
      setIsLoading(false);
      // const error = err?.response?.data?.errors?.[0];
      // if (error?.type === "invalid_request_error") {
      //   setIsValidUserName(false);
      //   setErrorMsg(alreadyExistUsername);
      // }
    }
  };

  const renderImageAndTitle = () => {
    return (
      <>
        {!isLnAddressSetup && (
          <img
            src={rotationIcon}
            height="54px"
            width="54px"
            style={{ marginBottom: "13px" }}
          />
        )}
        <Text className="default-text" size={22} font="semibold">
          {setupLnAddress(currency === sats ? btc : currency)}
        </Text>
      </>
    );
  };

  return (
    <Box
      display="flex"
      // flexDirection="column"
      height="100%"
      className={customClass}
      boxSizing="border-box"
    >
      <Box className="setup-ln-address-container">
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          padding="10px"
        >
          {/**set user name for ln-address */}
          {isLnAddressSetup ? (
            <Box
              display="flex"
              flexDirection="column"
              justifyContent="space-around"
              width="100%"
              alignItems="center"
              textAlign="center"
              minHeight="256px"
              className="ln-address-setup-box"
            >
              <Box>
                {renderImageAndTitle()}
                <Text
                  className="grey-text"
                  size={textSize}
                  font="regular"
                  sx={{ textAlign: "center" }}
                >
                  {setUpLnSubMessage}
                </Text>
              </Box>
              <Box className="username">
                <Box width="100%">
                  <Text className="grey-text" size={14} font="regular">
                    {setYourUserName}
                  </Text>
                  <Input
                    fullWidth
                    customClass={`mt-6 username-txt ${
                      !isValidUserName && "error-input"
                    }`}
                    placeholder={"test"}
                    name="username"
                    value={userName}
                    onChange={(e) => {
                      // Convert input to lowercase for consistency.
                      let val = e.target.value.toLowerCase();
                      // Remove any characters that are not lowercase letters, digits, or spaces.
                      val = val.replace(/[^a-z0-9\s]/g, "");
                      setUserName(val);
                    }}
                    inputProps={{ maxLength: 32 }}
                  />
                  {!isValidUserName && (
                    <Text
                      className="error-text"
                      size={isFromBrowser ? 14 : 12}
                      font="regular"
                      sx={{ marginTop: "5px", textAlign: "left" }}
                    >
                      {errorMsg}
                    </Text>
                  )}
                </Box>
              </Box>
              <LnAddress userName={userName} isFromBrowser={isFromBrowser} />
            </Box>
          ) : (
            //setup ln-address info
            <>
              {renderImageAndTitle()}
              <List
                sx={{
                  listStyleType: "disc",
                  pl: 3,
                  color: "#848b9e",
                  marginTop: "10px",
                }}
              >
                <ListItem sx={{ display: "list-item" }}>
                  <Text className="grey-text" size={textSize} font="regular">
                    {setupLNAddressMessages[0]}
                  </Text>
                </ListItem>
                <ListItem sx={{ display: "list-item" }}>
                  <Text className="grey-text" size={textSize} font="regular">
                    {setupLNAddressMessages[1]}
                  </Text>
                </ListItem>
              </List>
            </>
          )}
        </Box>
        <Box className={isFromBrowser ? "options-footer-btn" : "footer"}>
          <Button
            fullWidth
            variant="contained"
            className="txt-uppercase"
            label={!isLnAddressSetup ? setUpNow : save}
            onClick={() => (!isLnAddressSetup ? handleSetup() : handleSave())}
            sx={!isFromBrowser ? { margin: "14px 20px" } : {}}
            disabled={isLnAddressSetup && (!isValidUserName || !userName)}
            loading={isLoading}
          />
        </Box>
      </Box>
    </Box>
  );
}

export default SetupLnAddressCommon;
